import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/network/news',
            name: 'news',
            component: () => import("./views/news.vue"),
            meta: {
                hasBar: true,
                bottomCutFixed: true
            }
        },
        {
            path: '/network/news/:postId',
            name: 'newsDetail',
            component: () => import("./views/newsDetail.vue"),
            meta: {
                hideTopCut: true,
                hasBar: false
            }
        }
    ];
};